module.exports = __webpack_public_path__ + "img/BCD.16f95ed0.svg";